@use '../../../../../styles/all' as *;
// Local Mixin
@use '../../../styles/websheetMixin' as *;

.c-TermsAndConditionsBase {
  padding-inline: 16px;
  padding-top: 15px;
  padding-bottom: 0;
  position: relative;
  background-color: var(--color-body-background, #ffffff);

  &__content {
    @include flex-1;
    color: var(--color-body, #0f172b);

    .rich-editor * {
      color: var(--color-body, #0f172b);
    }
  }

  &__logo {
    margin: 0;
    text-align: center;
    height: 60px;
    img {
      height: 100%;
    }
  }

  &__title {
    font-size: var(--h1-size, 24px);
    font-weight: var(--ft-weight-bold, bold);
    color: var(--color-heading, #0f172b);
    margin: auto;
    margin: 0 auto;
    padding: 0 20px;
    text-align: center;
  }

  &--notext {
    margin: 0;
  }

  &__footer {
    // background-color: transparent;
    position: sticky;
    bottom: -1px;
    width: 100%;
    left: 0;
    padding: 15px 0;
    z-index: 10;
    background-color: var(--background, transparent);

    &--preview {
      padding: calc(15px + 7px) 0;
    }
  }
}
